import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Signup.module.css';
import apiService from '../services/api';

function Signup() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        password: '',
        passwordConfirm: '',
        phone: '',
        email: '',
        address: '',
        referralCode: '',
        referralSource: ''
    });

    const [agreeAll, setAgreeAll] = useState(false);
    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        // 에러 초기화
        if (errors[e.target.name]) {
            setErrors({
                ...errors,
                [e.target.name]: ''
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.password || formData.password.length < 8) {
            newErrors.password = '비밀번호는 8자 이상 입력해주세요';
        }

        if (formData.password !== formData.passwordConfirm) {
            newErrors.passwordConfirm = '비밀번호가 일치하지 않습니다';
        }

        if (!formData.name) {
            newErrors.name = '이름을 입력해주세요';
        }

        if (!formData.phone) {
            newErrors.phone = '전화번호를 입력해주세요';
        }

        if (!formData.email) {
            newErrors.email = '이메일을 입력해주세요';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = '올바른 이메일 형식이 아닙니다';
        }

        if (!agreeAll) {
            newErrors.agreement = '이용약관 및 개인정보처리방침에 동의해주세요';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }

        if (isSubmitting) {
            return;
        }

        setIsSubmitting(true);

        try {
            // 서버에 전송할 데이터 준비 (passwordConfirm 제외)
            const signupData = {
                name: formData.name,
                email: formData.email,
                password: formData.password,
                phone: formData.phone,
            };

            // 선택사항 필드는 값이 있을 때만 추가
            if (formData.address) {
                signupData.address = formData.address;
            }
            if (formData.referralCode) {
                signupData.referralCode = formData.referralCode;
            }
            if (formData.referralSource) {
                signupData.referralSource = formData.referralSource;
            }

            console.log('Signup attempt:', { ...signupData, password: '***' });
            
            const response = await apiService.signup(signupData);
            console.log('Signup response:', response);
            
            alert('회원가입 신청이 완료되었습니다.\n승인 대기 중입니다. 승인 완료 후 로그인이 가능합니다.');
            
            // 로그인 페이지로 이동
            navigate('/login');
        } catch (error) {
            console.error('Signup error:', error);
            alert(error.message || '회원가입에 실패했습니다. 다시 시도해주세요.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={styles.signupWrap}>
            <div className={styles.signupContainer}>
                <div className={styles.signupBox}>
                    <h2 className={styles.signupTitle}>회원가입 신청</h2>

                    <form onSubmit={handleSubmit} className={styles.signupForm}>

                        {/*                         <div className={styles.formGroup}>
                            <label htmlFor="id" className={styles.label}>
                                ID<span className={styles.required}>*</span>
                            </label>
                            <div className={styles.inputWithButton}>
                                <input
                                    type="text"
                                    id="id"
                                    name="id"
                                    value={formData.id}
                                    onChange={handleChange}
                                    className={`${styles.input} ${errors.id ? styles.inputError : ''}`}
                                    placeholder="아이디"
                                />
                                <button type="button" className={styles.checkButton}>
                                    중복확인
                                </button>
                            </div>
                            {errors.id && <span className={styles.errorText}>{errors.id}</span>}
                        </div> */}
                        <div className={styles.formGroup}>
                            <label htmlFor="name" className={styles.label}>
                                이름<span className={styles.required}>*</span>
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`${styles.input} ${errors.name ? styles.inputError : ''}`}
                                placeholder="이름"
                            />
                            {errors.name && <span className={styles.errorText}>{errors.name}</span>}
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="password" className={styles.label}>
                                비밀번호<span className={styles.required}>*</span>
                            </label>
                            <input
                                type="password"
                                id="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className={`${styles.input} ${errors.password ? styles.inputError : ''}`}
                                placeholder="숫자 + 영문 포함 8자 이상"
                            />
                            {errors.password && <span className={styles.errorText}>{errors.password}</span>}
                        </div>
                        <div className={styles.formGroup}>
                            <label htmlFor="passwordConfirm" className={styles.label}>
                                비밀번호 확인<span className={styles.required}>*</span>
                            </label>
                            <input
                                type="password"
                                id="passwordConfirm"
                                name="passwordConfirm"
                                value={formData.passwordConfirm}
                                onChange={handleChange}
                                className={`${styles.input} ${errors.passwordConfirm ? styles.inputError : ''}`}
                                placeholder="비밀번호 확인"
                            />
                            {errors.passwordConfirm && <span className={styles.errorText}>{errors.passwordConfirm}</span>}
                        </div>



                        <div className={styles.formGroup}>
                            <label htmlFor="phone" className={styles.label}>
                                phone<span className={styles.required}>*</span>
                            </label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className={`${styles.input} ${errors.phone ? styles.inputError : ''}`}
                                placeholder="010-1234-5678"
                            />
                            {errors.phone && <span className={styles.errorText}>{errors.phone}</span>}
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="email" className={styles.label}>
                                Email<span className={styles.required}>*</span>
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`${styles.input} ${errors.email ? styles.inputError : ''}`}
                                placeholder="example@domain.com"
                            />
                            {errors.email && <span className={styles.errorText}>{errors.email}</span>}
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="address" className={styles.label}>
                                가구 지역 또는 소속
                            </label>
                            <input
                                type="text"
                                id="address"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder=""
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="referralCode" className={styles.label}>
                                추천인
                            </label>
                            <input
                                type="text"
                                id="referralCode"
                                name="referralCode"
                                value={formData.referralCode}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder=""
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label htmlFor="referralSource" className={styles.label}>
                                협회에 가입하는 점
                            </label>
                            <input
                                type="text"
                                id="referralSource"
                                name="referralSource"
                                value={formData.referralSource}
                                onChange={handleChange}
                                className={styles.input}
                                placeholder="최대100자"
                            />
                        </div>

                        <div className={styles.agreementSection}>
                            <label className={styles.agreementLabel}>
                                <input
                                    type="checkbox"
                                    className={styles.checkbox}
                                    checked={agreeAll}
                                    onChange={(e) => setAgreeAll(e.target.checked)}
                                />
                                <span>이용약관 및 개인정보처리방침에 동의합니다.</span>
                            </label>
                            {errors.agreement && <span className={styles.errorText}>{errors.agreement}</span>}
                        </div>

                        <button 
                            type="submit" 
                            className={styles.submitButton}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? '처리 중...' : '회원가입 신청'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default Signup;